export const sortOptions = [
    { sort: 'emissions', label: 'Emissions' },
    { sort: 'cost', label: 'Lowest Cost' },
    { sort: 'depature-time', label: 'Departure time' },
    { sort: 'travel-time', label: 'Travel time' },
    { sort: 'arrival-time', label: 'Arrival time' },
    { sort: 'wait-time', label: 'Wait time' },
    { sort: 'walk-distance', label: 'Walking distance' },
    { sort: 'least-changes', label: 'Least changes' },
]

export const journeyTypeOptions = [
    { text: 'Single', value: 'single' },
    { text: 'Return', value: 'return' },
]

export const defaultMapFilters = [
    {
        name: 'None',
        count: '',
        icon: 'eye-blocked',
        slug: 'none',
    },
    {
        name: 'All',
        count: '',
        icon: 'eye',
        slug: 'all',
    },
]
